module.exports = __webpack_public_path__ + "static/fonts/iconfont.f1ea9a2a.eot";